export default __webpack_public_path__ + "static/media/mTop_3_p2.bb250836.jpeg";